import { ReactNode } from "react";

export const ModalButton = (props: {
    id: string;
    className: string;
    text: ReactNode;
    disabled?: boolean;
    onClick?: () => void;
}) => {
    const { className, text, id, disabled, onClick } = props;

    return (
        <button
            type="button"
            className={className}
            data-bs-toggle="modal"
            data-bs-target={`#${id}`}
            disabled={disabled}
            onClick={onClick}
        >
            {text}
        </button>
    );
};
